var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnderline01 = function SvgUnderline01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.584 21.505v-1.5h16.832v1.5zm4.13-5.185c-1.114-1.206-1.538-2.48-1.538-4.506V3h1.87v8.932q0 1.935 1.03 3.101Q10.103 16.2 12 16.2t2.924-1.167 1.029-3.1V3h1.87v8.814c0 2.025-.423 3.292-1.537 4.497S13.986 18 12 18s-3.172-.475-4.286-1.68"
  })));
};
export default SvgUnderline01;